export default ({ app, store }, inject) => {
  // Inject $hello(msg) in Vue, context and store.
  inject('custom$t', (str, obj) => {
    // use `$te` and `$t

    const i18nContents = store.state.settings.contents.i18nContents
    const i18nContent = i18nContents.find(
      (i18nContent) => i18nContent.language === app.i18n.locale
    )

    const i18n = app.i18n
    if (i18nContent) {
      const i18nObj = JSON.parse(i18nContent.overview)
      // str should be test.message.item so we need to split it by . and get the last item with recursive function
      const strParts = str.split('.')
      const i18nValue = getI18nValue(i18nObj, strParts)
      if (i18nValue !== undefined && i18nValue !== null) {
        return interpolate(i18nValue, obj)
      }
    }
    const companyId = store.state.settings.id
    const departmentId = store.state.settings.departmentId
    const customStr = str + 'Custom.' + companyId
    const customDepStr = departmentId ? str + 'Custom.department.' + departmentId : str + 'Custom.' + companyId
      
    return i18n.t && i18n.te
      ? customStr && i18n.te(customStr)
        ? i18n.t(customStr, obj)
        : customDepStr && i18n.te(customDepStr)
        ? i18n.t(customDepStr, obj)
        : i18n.t(str, obj)
      : i18n.t(str, obj)
  })
}

const getI18nValue = (i18nObj, strParts) => {
  if (strParts.length === 1) {
    const val = i18nObj?.[strParts[0]]
    return val === undefined || val === null ? null : val
  }
  return getI18nValue(i18nObj?.[strParts[0]], strParts.slice(1))
}

/** Replaces {key} in str with obj[key]. e.g. "{count} adet" + { count: 1 } => "1 adet" */
const interpolate = (str, obj) => {
  if (typeof str !== 'string') return str
  if (!obj || typeof obj !== 'object') return str
  return str.replace(/\{(\w+)\}/g, (_, key) => {
    return obj[key] !== undefined && obj[key] !== null ? String(obj[key]) : `{${key}}`
  })
}
